//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
  name: 'product-card-preview-audio',
  props: {
    element: Object,
    progress: Object,
  },
  data() {
    return {
      waveformWidth: 0,
    };
  },
  computed: {
    ...mapState({
      windowWidth: state => state.browser.window.width,
    }),
    // classProgressStatus: function () {
    //   let widthElapsed = 0;
    //
    //   const widthTotal = this.waveformWidth;
    //   widthElapsed = (this.progress.timeElapsed * widthTotal) / this.progress.timeTotal;
    //
    //   if (this.progress.timeTotal === 0) {
    //     widthElapsed = 0;
    //   }
    //
    //   const classObject = {
    //     opacity: 1,
    //     // waveformHeight are larger in PreviewAudio.vue (ProductPage)
    //     // clip: `rect(0,${widthElapsed}px,${_.get(this.waveformHeight, '', 3)}rem,0)`,
    //     clip: `rect(0,${widthElapsed}px,${this.waveformHeight || 3}rem,0)`,
    //   };
    //
    //   return classObject;
    // },
    uniqId() {
      const unixTime = +new Date();
      return this.element.id + unixTime;
    },
    maskWidth() {
      let widthElapsed = 0;

      const widthTotal = this.waveformWidth;
      widthElapsed = (this.progress.timeElapsed * widthTotal) / this.progress.timeTotal;

      if (this.progress.timeTotal === 0) {
        widthElapsed = 0;
      }
      return widthElapsed;
    },
  },
  watch: {
    windowWidth() {
      this.updateWaveformWidth();
    },
  },
  mounted() {
    this.updateWaveformWidth();
  },
  methods: {
    updateWaveformWidth() {
      // update waveform every time when hit
      this.waveformWidth = this.$refs.waveformWrapper.offsetWidth;
      this.$emit('update-waveform-width', this.$refs.waveformWrapper.offsetWidth);
    },
  },
};
